module.exports = __webpack_public_path__ + "static/img/fwkg.c8eeaf4.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/fwkg.svg
// module id = c+7y
// module chunks = 2